export const VIEW_TRANSITION_LOG_TAG = '[ViewTransition]';

export const BROWSER_BACK_NAVIGATION_DETECTED_MESSAGE = 'Browser back navigation detected';
export const NAVIGATION_HAS_NATIVE_TRANSITION_MESSAGE = 'Navigation has native transition';

export const TRANSITION_MODIFIERS = {
    DEFAULT: 'view-transition-default',
    PRODUCT_SWITCH: 'view-transition-product-switch',
    HORIZONTAL_SLIDE: 'view-transition-horizontal-slide',
    BACKWARDS: 'view-transition-backwards',
    EXCLUDE_HEADER: 'view-transition-modifier-exclude-header',
    EXCLUDE_BOTTOM_NAV: 'view-transition-modifier-exclude-bottom-nav',
    EXCLUDE_BETSLIP: 'view-transition-modifier-exclude-betslip',
    EXCLUDE_QUICK_BET: 'view-transition-modifier-exclude-quick-bet',
} as const;

export const TRANSITION_PATHS = {
    ACCOUNT_MENU_OVERLAY_PATH: ':menu',
    ACCOUNT_MENU_PATH: '/menu',
    AZ_MENU_PATH: '/product-menu',
    EVENT_PATH: '/events',
    EVENT_OVERLAY_PATH: ':event',
    CASINO_PATH: '/games',
    OVERLAY_PATH: 'overlay:',
    MYACCOUNT_PATH: '/myaccount',
    ACCOUNT_SETTINGS_PATH: '/settings',
} as const;

export const EXCLUDED_ROUTES = ['/inbox', '/payments', '/p/about-us', '/p/betting-guide'] as const;

export const ZERO_DELAY_TRANSITION_CONFIG = {
    transitionDelay: 0,
    contentStartTimeout: 0,
} as const;

export const BACK_NAVIGATION_DEBOUNCE = 100;
